import React from "react";
import {mailtoUrl} from "../utils/format";
import {EnvelopeIcon} from "./icons";

/**
 * An email address as shown to the user: a mailto link when it looks like a
 * valid address, plain text otherwise.
 *
 * @param {{email?: string|null}} props
 */
const EmailLink = ({email}) => {
    if (!email) return null;
    const url = mailtoUrl(email);
    if (!url) return <>{email}</>;
    return (
        <a href={url} title="Enviar e-mail" className="text-decoration-none">
            <span className="me-1 text-secondary">
                <EnvelopeIcon />
            </span>
            {email}
        </a>
    );
};

export default EmailLink;
